module.exports = __webpack_public_path__ + "img/product_120.a8fd398.webp";